<template>
  <div class="n_continer">
    <div class="n_content">
      <div class="n_top">
        <div class="n_flex n_comint">
          <p class="n_order">订单编号</p>
          <p class="n_ordersain">{{objInfo.sn}}</p>
        </div>
        <div class="n_flex n_comint">
          <p class="n_order">
            订单金额
            <span
              v-if="objInfo.type != 'integral' && objInfo.type != 'integral_group' && objInfo.type != 'unionCard'"
            >(含运费)</span>
          </p>
          <p class="n_price">
            <span v-if="objInfo.type != 'integral' && objInfo.type != 'integral_group'">¥</span>
            <span
              v-if="objInfo.type == 'integral' || objInfo.type == 'integral_group'"
            >{{orderInfo.score}}</span>
            <span v-else>{{orderInfo.pay_money_dollar}}</span>
          </p>
        </div>
        <div
          class="n_flex n_comint"
          v-if="objInfo.type == 'integral' || objInfo.type == 'integral_group'"
        >
          <p class="n_order">运费</p>
          <p class="n_price">¥{{orderInfo.shipping_money_dollar}}</p>
        </div>
      </div>
      <div class="n_pay">
        <!-- v-if="goods_type == 'integral' || goods_type == 'integral_group '" -->
        <div
          v-if="(objInfo.type == 'integral' || objInfo.type == 'integral_group') && objInfo.transfer_ids == 0"
        >
          <div class="n_left n_flex" @click="openTransFg">
            <div class="n_flex">
              <img class="n_payImg" src="../assets/img/duihuanquan.png" alt />
              <div class="n_margin">
                <p class="n_cmitc">提货卡</p>
              </div>
            </div>
            <div>
              <span>{{numIndex > 0 ? '已选择' :'请选择'}}</span>
              <span class="iconfont iconnext"></span>
            </div>
          </div>
        </div>
        <!-- v-if="price > 0" -->
        <!-- <div class="n_left n_flex" v-if="orderInfo.order_money_dollar > 0">
          <div class="n_flex">
            <img class="n_payImg" src="../assets/img/icon_zhifu.png" alt />
            <div class="n_margin">
              <p class="n_tipay">微信支付</p>
              <p class="n_cmitc">微信安全支付</p>
            </div>
          </div>
          <span class="iconfont iconselected"></span>
        </div>-->
      </div>
      <div class="n_btn" @click="goPay">确认支付</div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <van-loading text-color="#0094ff" />
      </div>
    </van-overlay>
    <van-action-sheet v-model="isSheet" title="请选择" :closeable="false">
      <div class="content">
        <van-list v-model="loading" :finished="finished" @load="onLoad">
          <div class="n_list" v-for="(item,index) in transFre" :key="item.id">
            <div class="n_left">
              <div class="n_title">{{item.title}}--{{item.id}}</div>
              <div class="n_time">有效期至：{{item.end_time}}</div>
            </div>
            <div class="n_right" @click="selectTransFg(index)">
              <span class="n_num">余{{item.plus_score}}</span>
              <span
                :class="['iconfont', item.checked == true ? 'iconselected' : 'iconweixuanzhong']"
              ></span>
            </div>
          </div>
        </van-list>
        <div class="n_cancel" @click="cancelFg">确定</div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="isCode" show-cancel-button @confirm="bankPayFg" @cancel="cancelCtFg">
      <div class="n_code">
        <div class="input_code">请输入验证码</div>
        <div class="time_code">
          验证码已发送至 +86 {{bankInfo.phone}}
          <span>{{sign == false ? '' : codehtml + 'S'}}</span>
        </div>
        <input type="number" v-model="code" placeholder="请输入验证码" />
        <a href="javascript:;" v-if="sign == false" @click="againSendPaySmsCode">重新获取</a>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
import httpPay from '../../httppay.js'
import { add, subtract, multiply, divide } from '../public/floatPublic.js'
import masterPath from '../../config.js'
export default {
  data() {
    return {
      orderSn: '',
      price: '',
      order_id: '',
      transFre: [], //积分
      integral_key: '', //积分ID
      ismsg: 'iconweixuanzhong',
      show: false,
      goods_type: '',
      isSheet: false,
      page: 0,
      loading: false,
      finished: false,
      numIndex: 0,
      objInfo: {},
      orderInfo: {},
      isCode: false,
      codehtml: 60, //倒计时秒
      sign: false, //倒计时
      code: '',
      bankInfo: {},
    }
  },
  created() {
    // this.price = this.$route.query.price
    // this.shipping_fee = this.$route.query.shipping_fee
    // this.orderSn = this.$route.query.orderSn
    this.getStringFg(window.location.href)
    this.getOrderMessage()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    cancelCtFg() {
      this.show = false
      this.isCode = false
    },
    //查询是否绑定银行卡
    getUserBank(authInfo) {
      httpPay('Client.getUserBank', {
        type: 2,
        merchant_id: this.objInfo.mechId,
        token: this.objInfo.token,
      }).then((res) => {
        this.bankInfo = res.content
        var reg = /^(\d{3})\d{4}(\d{4})$/
        let tel = res.content.phone
        this.bankInfo.phone = tel.replace(reg, '$1****$2')
      })
    },
    //获取订单信息
    async getOrderMessage() {
      if (this.objInfo.type == 'unionCard') {
        let res = await httpPay('ClientAlliance.getPayOrderData', {
          order_no: this.objInfo.sn,
          merchant_id: this.objInfo.mechId,
          token: this.objInfo.token,
        })
        this.orderInfo = res.content
      } else {
        let res = await httpPay('ClientOrder.getPayOrderData', {
          order_no: this.objInfo.sn,
          merchant_id: this.objInfo.mechId,
          token: this.objInfo.token,
        })
        this.orderInfo = res.content
      }
    },
    //获取url字符串
    getStringFg(url) {
      console.log(url)
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = url.substr(url.indexOf('?') + 1)
      params = decodeURIComponent(params)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      console.log(obj)
      this.objInfo = obj
    },
    cancelFg() {
      this.isSheet = false
    },
    openTransFg() {
      this.isSheet = true
    },
    selectTransFg(index) {
      console.log(index, this.transFre[index].checked)
      if (
        this.orderInfo.score > this.numIndex ||
        this.transFre[index].checked == true
      ) {
        if (this.transFre[index].checked == false) {
          this.numIndex = add(this.numIndex, this.transFre[index].plus_score)
        } else {
          this.numIndex = subtract(
            this.numIndex,
            this.transFre[index].plus_score
          )
        }
        this.transFre[index].checked = !this.transFre[index].checked
      } else {
        Toast('提货卡选择上限')
      }
    },
    onLoad() {
      this.page++
      this.getTransferScoreList()
    },
    // 2021051215334178336910804
    //支付
    async goPay() {
      // if (!this.isWexinLogin) {
      //   Toast('请去微信端进行支付')
      //   return
      // }
      if (
        this.numIndex <= 0 &&
        (this.objInfo.type == 'integral' ||
          this.objInfo.type == 'integral_group') &&
        this.objInfo.transfer_ids == 0
      ) {
        Toast('请选择使用的提货卡')
        return
      }
      let arr = []
      this.transFre.map((item) => {
        if (item.checked == true) {
          arr.push(item.id)
        }
      })
      let params = {}
      params = {
        order_no: this.objInfo.sn,
        integral_key: arr.join(','),
        token: this.objInfo.token,
        merchant_id: this.objInfo.mechId,
        pay_type: this.objInfo.seler == 'rule' ? 'bank' : 'wx',
      }
      let tparams = {
        order_no: this.objInfo.sn,
        token: this.objInfo.token,
        merchant_id: this.objInfo.mechId,
      }
      this.show = true
      let res = await httpPay(
        this.objInfo.type == 'unionCard'
          ? 'ClientAlliance.orderPay'
          : 'ClientOrder.orderPay',
        this.objInfo.type == 'unionCard' ? tparams : params
      )
      if (res.status == 200) {
        //快捷支付
        if (this.objInfo.seler == 'rule') {
          this.getUserBank()
          this.isCode = true
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          return
        }
        if (
          JSON.stringify(res.content.pay_info) != '{}' &&
          res.content.pay_info
        ) {
          let mypay = JSON.parse(res.content.pay_info)
          if (typeof WeixinJSBridge == 'undefined') {
            if (document.addEventListener) {
              document.addEventListener(
                'WeixinJSBridgeReady',
                this.onBridgeReady
              )
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady)
              document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady)
            }
          } else {
            this.onBridgeReady(mypay)
          }
        } else {
          window.location.href = `${
            masterPath.linkUrl
          }://${localStorage.getItem(
            'domain'
          )}/yj_project/#/successOrder?payInfo=payInfo`
        }
      } else {
        Toast(res.msg)
      }
      this.show = false
    },
    async onBridgeReady(paydata, payFormData) {
      let self = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: paydata.appId, //公众号名称，由商户传入
          timeStamp: paydata.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: paydata.nonceStr, //随机串
          package: paydata.package,
          signType: paydata.signType, //微信签名方式：
          paySign: paydata.paySign, //微信签名
        },
        function (res) {
          console.log(res)
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // self.isClick = false
            // window.location.href =
            //   'http://test-yj.dongguajie.cn/yj_project/?code=061m4Z0w379yrW22LT1w3H0VT31m4Z0t&state=state#/home'
            self.$router.replace({ path: './home' })
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            self.isClick = false
            Toast('支付取消!')
          } else {
            self.isClick = false
            Toast('支付失败!')
          }
        }
      )
    },
    //  银行卡支付确认支付
    async bankPayFg() {
      let res = await httpPay('ClientOrder.bankPay', {
        order_no: this.objInfo.sn,
        code: this.code,
        merchant_id: this.objInfo.mechId,
        token: this.objInfo.token,
      })
      if (res.status == 200) {
        window.location.href = `${masterPath.linkUrl}://${localStorage.getItem(
          'domain'
        )}/yj_project/#/successOrder?payInfo=payInfo`
      } else {
        Toast(res.msg)
        this.show = false
        this.isCode = false
      }
    },
    //银行卡支付再次发送验证码-
    async againSendPaySmsCode() {
      let res = await httpPay('ClientOrder.againSendPaySmsCode', {
        order_no: this.objInfo.sn,
        merchant_id: this.objInfo.mechId,
        token: this.objInfo.token,
      })
      if (res.status == 200) {
        this.codehtml = 60
        this.sign = true
        let tim = setInterval(() => {
          this.codehtml = this.codehtml - 1
          if (this.codehtml <= 0) {
            clearInterval(tim)
            this.sign = false
            return false
          }
        }, 1000)
      } else {
        Toast(res.msg)
      }
      console.log(res)
    },
    //获取提货卡
    async getTransferScoreList() {
      let res = await httpPay('ClientOrder.getTransferScoreList', {
        page: this.page,
        size: 10,
        merchant_id: this.objInfo.mechId,
        token: this.objInfo.token,
      })
      this.loading = false
      res.content.list.map((item) => {
        item.checked = false
      })
      // if (res.content.list.length == 1) {
      //   res.content.list[0].checked = true
      //   this.numIndex = add(this.numIndex, res.content.list[0].plus_score)
      // }
      this.transFre = this.transFre.concat(res.content.list)
      this.finished = res.content.list == 0
      console.log(res)
    },
  },
}
</script>
<style lang="scss" scoped>
.n_cancel {
  text-align: center;
  color: #ee0a24;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.iconselected {
  color: #ee0a24;
}
.iconfont {
  font-size: 36px;
}
.n_continer {
  width: 100vw;
  height: 100vh;
  background: rgba(247, 248, 250, 1);
}
.n_content {
  padding: 20px;
}
.n_top {
  background: #ffffff;
  border-radius: 14px 14px 0px 0px;
}
.n_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.n_comint p {
  padding: 23px 30px;
}
.n_order {
  font-size: 26px;
  color: #333333;
}
.n_ordersain {
  font-size: 26px;
  color: #999999;
}
.n_price {
  font-size: 26px;
  color: #f0240e;
}
.n_payImg {
  width: 72px;
  height: 72px;
}
.n_radio {
  width: 40px;
  height: 40px;
}
.n_margin {
  margin-left: 24px;
}
.n_pay {
  background: #ffffff;
  margin-top: 20px;
}
.n_left {
  border-radius: 14px 14px 0px 0px;
  padding: 19px 40px 19px 24px;
}
.n_tipay {
  font-size: 28px;
  color: #323233;
}
.n_cmitc {
  font-size: 24px;
  color: #969799;
}
.n_btn {
  width: 686px;
  height: 96px;
  line-height: 96px;
  text-align: center;
  background: #ee0a24;
  border-radius: 44px;
  font-size: 32px;
  color: #ffffff;
  margin-top: 100px;
}
.content {
  padding: 30px;
}
.n_list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff9f9;
  border-radius: 14px;
  padding: 30px 40px;
  margin-bottom: 20px;
}
.n_title {
  font-size: 32px;
  color: #323233;
}
.n_time {
  font-size: 24px;
  color: #969799;
  margin-top: 12px;
}
.n_num {
  font-size: 32px;
  color: #333333;
  margin-right: 26px;
}
.n_code {
  .input_code {
    font-size: 32px;
    color: #323233;
    text-align: center;
    font-weight: 700;
    padding-top: 36px;
  }
  .time_code {
    font-size: 28px;
    font-weight: 400;
    color: #969799;
    text-align: center;
    margin-top: 16px;
    span {
      font-size: 28px;
      font-weight: 400;
      color: #ee0a24;
    }
  }
  input {
    display: block;
    width: 280px;
    height: 92px;
    background: #ffffff;
    border-radius: 8px;
    border: 1px solid #e5e5e5;
    padding: 0 54px;
    box-sizing: border-box;
    margin: 0 auto;
    font-size: 28px;
    font-weight: 400;
    color: #969799;
    margin-top: 36px;
  }
  a {
    display: block;
    text-align: center;
    font-size: 28px;
    font-weight: 400;
    color: #ee0a24;
    text-decoration: underline;
    margin-top: 26px;
  }
}
</style>
